/* unplugin-vue-components disabled */import { render } from "./my.vue?vue&type=template&id=1c9bde51&scoped=true"
import script from "./my.vue?vue&type=script&lang=js"
export * from "./my.vue?vue&type=script&lang=js"

import "./my.vue?vue&type=style&index=0&id=1c9bde51&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9bde51"]])

export default __exports__